import { render, staticRenderFns } from "./app.vue?vue&type=template&id=590954ba&scoped=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"
import style0 from "./app.vue?vue&type=style&index=0&id=590954ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590954ba",
  null
  
)

export default component.exports